import Home from "@/components/views/Home";
import Roles from "@/components/views/Admin/Roles";
import Role from "@/components/views/Admin/Role";
import Users from "@/components/views/Admin/Users";
import User from "@/components/views/Admin/User";
import MealTypes from "@/components/views/Editor/MealTypes";
import MealType from "@/components/views/Editor/MealType";
import MealStyles from "@/components/views/Editor/MealStyles";
import MealStyle from "@/components/views/Editor/MealStyle";
import Ingredients from "@/components/views/Editor/Ingredients";
import Ingredient from "@/components/views/Editor/Ingredient";
import Locales from "@/components/views/Editor/Locales";
import Locale from "@/components/views/Editor/Locale";
import Meals from "@/components/views/Editor/Meals";
import Meal from "@/components/views/Editor/Meal";
import Markets from "@/components/views/Editor/Markets";
import Market from "@/components/views/Editor/Market";
import Recipes from "@/components/views/Editor/Recipes";
import Recipe from "@/components/views/Editor/Recipe";
import ServingSizes from "@/components/views/Editor/ServingSizes";
import ServingSize from "@/components/views/Editor/ServingSize";
import Tags from "@/components/views/Editor/Tags";
import Tag from "@/components/views/Editor/Tag";
import Snapshots from "@/components/views/Editor/Snapshots";
import Snapshot from "@/components/views/Editor/Snapshot";
import Problems from "@/components/views/Editor/Problems";

export default [
    //home
    { path: "/", component: Home },

    // admin routes
    { path: '/roles', component: Roles, keepAlive: true },
    { path: '/role/:id', component: Role, keepAlive: true },
    { path: '/users', component: Users, keepAlive: true },
    { path: '/user/:id', component: User, keepAlive: true },

    // editor routes
    { path: '/', component: Home, keepAlive: true },
    { path: '/meal-types', component: MealTypes, keepAlive: true },
    { path: '/meal-type/:id', component: MealType, keepAlive: true },
    { path: '/meal-styles', component: MealStyles, keepAlive: true },
    { path: '/meal-style/:id', component: MealStyle, keepAlive: true },
    { path: '/ingredients', component: Ingredients, keepAlive: true },
    { path: '/ingredient/:id', component: Ingredient, keepAlive: true },
    { path: '/locales', component: Locales, keepAlive: true },
    { path: '/locale/:id', component: Locale, keepAlive: true },
    { path: '/meals', component: Meals, keepAlive: true },
    { path: '/meal/:id', component: Meal, keepAlive: true },
    { path: '/markets', component: Markets, keepAlive: true },
    { path: '/market/:id', component: Market, keepAlive: true },
    { path: '/recipes', component: Recipes, keepAlive: true },
    { path: '/recipe/:id', component: Recipe, keepAlive: true },
    { path: '/serving-sizes', component: ServingSizes, keepAlive: true },
    { path: '/serving-size/:id', component: ServingSize, keepAlive: true },
    { path: '/snapshots', component: Snapshots, keepAlive: true },
    { path: '/snapshot/:id', component: Snapshot, keepAlive: true },
    { path: '/tags', component: Tags, keepAlive: true },
    { path: '/tag/:id', component: Tag, keepAlive: true },
    { path: '/problems/:type', component: Problems, keepAlive: true },

]
